import Autocomplete from "@mui/material/Autocomplete";

export default Autocomplete;
